import withRouter from "components/Common/withRouter"
import GlobalState from "contexts/GlobalState"
import React, { useEffect, useContext } from "react"

const Logout = props => {
  const [state, setState] = useContext(GlobalState)

  useEffect(() => {
    console.log("Logout")
    try {
      localStorage.removeItem("session_id")
      localStorage.removeItem("api_token")

      // Set logout event flag in localstorage for all tabs to logout
      localStorage.setItem("logout", Date.now())

      // Call Keycloak instances logout function that is set in the GlobalState
      if (state.logout) {
        state.logout()
      }
      setState({})
    } catch (error) {
      console.log(error)
    }
  }, [])

  return <></>
}

Logout.propTypes = {}

export default withRouter(Logout)
